module.exports = __webpack_public_path__ + "img/laptop-four.82a96706.png";